import React from "react";
import { useFetchCustomQueryCoursewise } from "../../api/fetchData";
import { Skeleton, Text, TableContainer, Table, Thead, Th, Tbody, Tr, Td, useMediaQuery } from "@chakra-ui/react";

const CoursewiseCount = ({ matrix, module, query }) => {
    const [isLagerThan420] = useMediaQuery('(min-width: 420px)');
    const [isLagerThan600] = useMediaQuery('(min-width: 600px)');
    const [isLagerThan800] = useMediaQuery('(min-width: 800px)');

    const { data } = useFetchCustomQueryCoursewise(module, query);

    // if ( !data ) {
    //     return <Skeleton fadeDuration={5} height={{ base: '777px' }} />
    // }

    return (
        <Skeleton fadeDuration={5} height={isLagerThan420 && isLagerThan800 ? '868px' : !isLagerThan420 && !isLagerThan800 ? '1539px' : isLagerThan420 && !isLagerThan600 ? '1399px' : '779px'} isLoaded={data}>
            {data &&
                <TableContainer
                    whiteSpace={{ base: "nowrap", xs: "wrap", sm: "wrap", md: "nowrap", lg: "nowrap" }}
                    marginX={{ base: "0px", sm: "0px", md: "0px" }}
                    overflowX="auto"
                    sx={{
                        '&::-webkit-scrollbar': {
                            height: '6px',
                        },
                        '&::-webkit-scrollbar-track': {
                            background: 'gray.100',
                            borderRadius: '3px',
                        },
                        '&::-webkit-scrollbar-thumb': {
                            background: 'gray.400',
                            borderRadius: '3px',
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: 'gray.600',
                        },
                    }}
                >
                    <Table size={{ base: 'sm', xs: 'xs', sm: 'xs', md: 'sm', lg: 'md' }} variant="simple">
                        <Thead>
                            <Tr>
                              <Th
                                  sx={{
                                      borderColor: 'gray.300',
                                      paddingLeft: { base: '12px', sm: '10px', md: '15px' },
                                      paddingRight: { base: '8px', sm: '6px', md: '10px' },
                                      fontSize: { base: '12px', sm: '11px', md: '14px' }
                                  }}
                              >

                              </Th>
                                <Th
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingLeft: { base: '12px', sm: '10px', md: '15px' },
                                        paddingRight: { base: '8px', sm: '6px', md: '10px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    Stage
                                </Th>
                                <Th
                                    isNumeric
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingX: { base: '6px', sm: '4px', md: '8px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    Total
                                </Th>
                                <Th
                                    isNumeric
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingX: { base: '6px', sm: '4px', md: '8px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    CC
                                </Th>
                                <Th
                                    isNumeric
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingX: { base: '6px', sm: '4px', md: '8px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    HM
                                </Th>
                                <Th
                                    isNumeric
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingX: { base: '6px', sm: '4px', md: '8px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    PC
                                </Th>
                                <Th
                                    isNumeric
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingX: { base: '6px', sm: '4px', md: '8px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    EM
                                </Th>
                                <Th
                                    isNumeric
                                    sx={{
                                        borderColor: 'gray.300',
                                        paddingX: { base: '6px', sm: '4px', md: '8px' },
                                        fontSize: { base: '12px', sm: '11px', md: '14px' }
                                    }}
                                >
                                    TT
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {matrix.map((report, index) => (
                                <Tr key={`tr-${index}`}>
                                  <Td
                                      key={`title-${index}`}
                                      sx={{
                                          paddingX: { base: '6px', sm: '4px', md: '8px' },
                                          paddingLeft: { base: '12px', sm: '10px', md: '15px' },
                                          paddingRight: { base: '8px', sm: '6px', md: '10px' },
                                          borderColor: 'blue.600'
                                      }}
                                  >
                                      <Text
                                        fontSize={{ base: '11px', sm: '10px', md: '13px' }}
                                        sx={{
                                          paddingX: { base: '30px', sm: '20px', md: '8px' }
                                        }}
                                      ></Text>

                                  </Td>
                                    <Td
                                        key={`title-${index}`}
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingLeft: { base: '12px', sm: '10px', md: '15px' },
                                            paddingRight: { base: '8px', sm: '6px', md: '10px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text fontSize={{ base: '11px', sm: '10px', md: '13px' }}>{report.title}</Text>

                                    </Td>
                                    <Td
                                        key={`total-${index}`}
                                        isNumeric
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingX: { base: '6px', sm: '4px', md: '8px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text key={`total-txt-${index}`} fontWeight='bold' fontSize={{ base: '11px', sm: '10px', md: '13px' }}>
                                            {
                                                (!Object.hasOwn(data[report.module], report.course_pc) ? 0 : Object.hasOwn(data[report.module][report.course_pc], report.query) ? data[report.module][report.course_pc][report.query] : 0) +
                                                (!Object.hasOwn(data[report.module], report.course_hm) ? 0 : Object.hasOwn(data[report.module][report.course_hm], report.query) ? data[report.module][report.course_hm][report.query] : 0) +
                                                (!Object.hasOwn(data[report.module], report.course_cc) ? 0 : Object.hasOwn(data[report.module][report.course_cc], report.query) ? data[report.module][report.course_cc][report.query] : 0) +
                                                (!Object.hasOwn(data[report.module], report.course_tt) ? 0 : Object.hasOwn(data[report.module][report.course_tt], report.query) ? data[report.module][report.course_tt][report.query] : 0) +
                                                (!Object.hasOwn(data[report.module], report.course_em) ? 0 : Object.hasOwn(data[report.module][report.course_em], report.query) ? data[report.module][report.course_em][report.query] : 0)
                                            }
                                        </Text>
                                    </Td>
                                    <Td
                                        key={`cc-${index}`}
                                        isNumeric
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingX: { base: '6px', sm: '4px', md: '8px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text key={`cc-txt-${index}`} fontSize={{ base: '11px', sm: '10px', md: '13px' }}>
                                            {!Object.hasOwn(data[report.module], report.course_cc) ? 0 : Object.hasOwn(data[report.module][report.course_cc], report.query) ? data[report.module][report.course_cc][report.query] : 0}
                                        </Text>
                                    </Td>
                                    <Td
                                        key={`hm-${index}`}
                                        isNumeric
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingX: { base: '6px', sm: '4px', md: '8px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text key={`hm-txt-${index}`} fontSize={{ base: '11px', sm: '10px', md: '13px' }}>
                                            {!Object.hasOwn(data[report.module], report.course_hm) ? 0 : Object.hasOwn(data[report.module][report.course_hm], report.query) ? data[report.module][report.course_hm][report.query] : 0}
                                        </Text>
                                    </Td>
                                    <Td
                                        key={`pc-${index}`}
                                        isNumeric
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingX: { base: '6px', sm: '4px', md: '8px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text key={`pc-txt-${index}`} fontSize={{ base: '11px', sm: '10px', md: '13px' }}>
                                            {!Object.hasOwn(data[report.module], report.course_pc) ? 0 : Object.hasOwn(data[report.module][report.course_pc], report.query) ? data[report.module][report.course_pc][report.query] : 0}
                                        </Text>
                                    </Td>
                                    <Td
                                        key={`em-${index}`}
                                        isNumeric
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingX: { base: '6px', sm: '4px', md: '8px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text key={`em-txt-${index}`} fontSize={{ base: '11px', sm: '10px', md: '13px' }}>
                                            {!Object.hasOwn(data[report.module], report.course_em) ? 0 : Object.hasOwn(data[report.module][report.course_em], report.query) ? data[report.module][report.course_em][report.query] : 0}
                                        </Text>
                                    </Td>
                                    <Td
                                        key={`tt-${index}`}
                                        isNumeric
                                        sx={{
                                            paddingY: { base: '6px', sm: '4px', md: '8px' },
                                            paddingX: { base: '6px', sm: '4px', md: '8px' },
                                            borderColor: 'blue.600'
                                        }}
                                    >
                                        <Text key={`tt-txt-${index}`} fontSize={{ base: '11px', sm: '10px', md: '13px' }}>
                                            {!Object.hasOwn(data[report.module], report.course_tt) ? 0 : Object.hasOwn(data[report.module][report.course_tt], report.query) ? data[report.module][report.course_tt][report.query] : 0}
                                        </Text>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            }
        </Skeleton>
    );
};

export default CoursewiseCount;
